
import React from 'react';

export default function FxRisks() {
  const risks = [
    {
      icon: 'ri-arrow-up-down-line',
      title: '為替変動リスク',
      desc: '為替レートは経済指標・政治情勢・自然災害など様々な要因で変動します。予想と逆方向に動けば損失が発生します。',
      measure: '損切り注文（ストップロス）を必ず設定し、損失を限定しましょう。',
    },
    {
      icon: 'ri-scales-line',
      title: 'レバレッジリスク',
      desc: '国内FXでは最大25倍のレバレッジが可能。少額で大きな取引ができる反面、損失も同じ倍率で拡大します。',
      measure: '初心者はレバレッジ1〜3倍程度に抑え、慣れてから徐々に上げましょう。',
    },
    {
      icon: 'ri-time-line',
      title: '金利変動リスク',
      desc: '各国の金利差によるスワップポイントは、金利政策の変更で変動します。プラスだったスワップがマイナスになることもあります。',
      measure: 'スワップポイント目的の長期保有は、金利動向を定期的にチェックしましょう。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '流動性リスク',
      desc: '早朝や年末年始、重要指標発表時などはスプレッドが広がったり、約定しにくくなることがあります。',
      measure: '流動性の低い時間帯の取引は避け、主要な取引時間帯を選びましょう。',
    },
    {
      icon: 'ri-computer-line',
      title: 'システムリスク',
      desc: 'インターネット回線の不具合やサーバー障害により、一時的に取引ができなくなる可能性があります。',
      measure: 'DMM FXは複数のバックアップ体制を整備。スマホアプリも併用すると安心です。',
    },
    {
      icon: 'ri-emotion-sad-line',
      title: '心理的リスク',
      desc: '損失を取り戻そうと無理な取引をしたり、利益確定が遅れたりと、感情に左右されやすいのが投資の難しさです。',
      measure: '取引ルールを事前に決め、感情に流されない冷静な判断を心がけましょう。',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-rose-100 rounded-lg mb-4">
            <i className="ri-alert-line text-2xl text-rose-600"></i>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">FX自体に存在するリスク</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            FXは投資商品である以上、一定のリスクが伴います。大切なのは、リスクを正しく理解し、適切に対処することです。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {risks.map((risk, i) => (
            <div
              key={i}
              className="bg-white border border-gray-100 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-10 h-10 bg-rose-50 rounded-lg flex items-center justify-center mb-4">
                <i className={`${risk.icon} text-xl text-rose-500`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{risk.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">{risk.desc}</p>
              <div className="bg-emerald-50 rounded-lg px-3 py-2.5">
                <p className="text-xs text-emerald-700 leading-relaxed flex items-start">
                  <i className="ri-shield-check-line text-emerald-500 mr-1.5 mt-0.5 w-3 h-3 flex items-center justify-center flex-shrink-0"></i>
                  <span>
                    <strong>対策：</strong>
                    {risk.measure}
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
